import { createFileRoute } from '@tanstack/react-router'

import { RecurringInvoiceDetailPage } from '@/pages/invoices/recurring-invoices/[id]/RecurringInvoiceDetailPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/invoices/recurring-invoices/$id/',
)({
  component: RecurringInvoiceDetailPage,
})
